import React, { FC, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { IncomingEmailAddressRule } from "../../../../../models/incomingEmailAddressRule";
import { getSettings } from "../../../../../services/get.data.service";
import isDuplicate from "../../shared/helpers/isDuplicate";
import SettingsDelete from "../../shared/settingsDelete";
import SettingsView from "../../shared/settingsView";
import { ResultsTableRowData, SettingsAction, SettingsParams, SettingsType } from "../types";
import SystemAccountForm from "./systemAccountForm";
import { deleteSetting } from "../../../../../services/delete.data.service";
import { ResponseData } from "../../../../../models";

const SystemAccountSettings: FC = () => {
  const { action, id }: SettingsParams = useParams();
  const [data, setData] = useState<IncomingEmailAddressRule[] | null>([]);

  const loadData = (): void => {
    getSettings<IncomingEmailAddressRule>("incomingemailaccountrules").then((response) => {
      setData(response.data);
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  const existingSystemAccount = data?.find((rule) => rule.incomingEmailAccountRuleId === Number(id));

  const rows: ResultsTableRowData[] | null =
    data &&
    data.map((rule) => {
      return {
        id: rule.incomingEmailAccountRuleId,
        data: [
          rule.emailAddress,
          rule.subject,
          rule.suppressAutoResponse ? "Yes" : "No",
          rule.classification?.name,
          rule.autoClose ? "Yes" : "No",
          rule.client?.clientName,
          <Link key={`lis-${rule.incomingEmailAccountRuleId}`} to={`/settings/systemaccounts/apply/${rule.incomingEmailAccountRuleId}`}>
            Apply Rule
          </Link>,
          <Link key={`lis-${rule.incomingEmailAccountRuleId}`} to={`/settings/systemaccounts/edit/${rule.incomingEmailAccountRuleId}`}>
            Edit
          </Link>,
          <Link key={`lis-${rule.incomingEmailAccountRuleId}`} to={`/settings/systemaccounts/delete/${rule.incomingEmailAccountRuleId}`}>
            Delete
          </Link>,
        ],
      };
    });

  return (
    <SettingsView
      headers={["Email", "Subject", "Suppress ACK", "Default Classification", "Autoclose", "Default Client", ""]}
      rows={rows}
      sortColumn={0}
      titleSingle="System Account"
      titlePlural="System Accounts"
      type={SettingsType.systemAccounts}
    >
    {data !== null && action !== SettingsAction.delete && 
      <SystemAccountForm 
        isDuplicate={(fieldToCheck, value): boolean=>{
          return isDuplicate(data.map((item)=>{
            return {
              id: item.incomingEmailAccountRuleId,
              value: item.emailAddress + item.subject
            };
          }), value, Number(id));
        }}
       existingSystemAccount={existingSystemAccount} 
       load={loadData}
      />
    }
    {action === SettingsAction.delete && existingSystemAccount !== undefined &&
      <SettingsDelete 
        message={`Are you sure you want to delete the system account ${existingSystemAccount.emailAddress}?`}
        onDelete={() => {
          return deleteSetting("incomingemailaccountrules", existingSystemAccount.incomingEmailAccountRuleId)
            .then((result: ResponseData<void>) => {
              if (!result.success) {
                throw new Error("Failed to delete system account.");
              }

              loadData();
            });
        }}
      />
    }
    </SettingsView>
  );
};
export default SystemAccountSettings;
